<template>
  <section class="table">
    <!-- BU SAYFADAKİ TABLOLAR WORDDEN TEXT EDİTORE KOPYALANARAK SAYFAYA EKLENMISTIR O YÜZDEN INLINE STYLELAR MEVCUT -->
    <v-container>
      <h2 class="pt-10">Trafik Sigortası Fiyatları</h2>
      <p class="mt-5">
        Size en iyi fiyatı bulmak için 20’den fazla sigorta şirketini
        karşılaştırıyoruz.
      </p>
      <template>
        <!-- Mobile tabs start -->
        <v-tabs
          :show-arrows="true"
          v-model="tab"
          active-class="category-table-tab--active"
          vertical
          class="pa-10 justify-center d-flex d-sm-none"
        >
          <v-tab
            class="category-table-tab mt-5"
            v-for="btn in buttons"
            :key="btn.id"
          >
            <h3 style="white-space:normal;">{{ btn.text }}</h3>
          </v-tab>
        </v-tabs>
        <!-- mobile tabs end -->
        <!-- large screen tabs start -->
        <v-tabs
          :show-arrows="true"
          v-model="tab"
          active-class="category-table-tab--active"
          class="d-none d-sm-flex justify-center"
          height="80"
        >
          <v-tab
            class="category-table-tab  mr-5"
            v-for="btn in buttons"
            :key="btn.id"
          >
            <h3 style="white-space:normal;">{{ btn.text }}</h3>
          </v-tab>
        </v-tabs>
        <!-- large screen tabs end -->

        <v-container>
          <v-row class="mt-5">
            <v-col cols="12" class="justify-space-between d-flex">
              <span class="table--info">Araç Türü: Otomobil</span>
              <span class="table--info"
                >{{ currentYear }} Trafik Sigortası Fiyatları</span
              >
            </v-col>
          </v-row>
        </v-container>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <table>
              <tbody>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #00B050;">Araç Türü</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #00B050;">1. Basamak</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #00B050;">4. Basamak</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #00B050;">7. Basamak</span></strong
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: black;">Otomobil</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">4.312 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">1.725 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">949 TL</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: black;">Kamyonet</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">5.636 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2.254 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">1.240 TL</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: black;">Traktör</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">882 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">353 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">194 TL</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: black;">Motosiklet</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">1.758 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">703 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">387 TL</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">Kamyon</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">12.063 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">4.825 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2.654 TL</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: black;"
                          >Minibüs (9-15 Koltuk)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">7.577 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">3.031 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">1.667 TL</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">Çekici</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">20.218 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">8.087 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">4.448 TL</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: black;"
                          >Otobüs (16-30 Koltuk)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">10.797 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">4.319 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2.375 TL</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">Taksi</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">11.160 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">4.464 TL</span>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <span style="color: black;">2.455 TL</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-5">
              **Tabloda yer alan trafik sigortası fiyatları tavan fiyatları
              içermektedir. (Basamağa göre hesaplanacak en yüksek primdir.)
            </div>
          </v-tab-item>
          <v-tab-item>
            <table>
              <tbody>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: #00B050;">Yıl</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #00B050;">Basamak No</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #00B050;"
                          >Hasarsızlık İndirimi (%)</span
                        ></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong
                        ><span style="color: #00B050;"
                          >Prim Artışı (%)</span
                        ></strong
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">4</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">7</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">45</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">-</span></strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">3</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">6</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">30</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">-</span></strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">2</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">5</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">15</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">-</span></strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">1</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">4</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">-</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">-</span></strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">2</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">3</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">-</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">50</span></strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">3</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">2</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">-</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">100</span></strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">4</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">1</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">-</span></strong>
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;line-height: NaN%;">
                      <strong><span style="color: black;">150</span></strong>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-5">
              ** Hasarsızlık indirimi ve prim artışı 4. Basamak baz alınarak
              hesaplanır. 1 yıllık poliçe döneminde kaza yapmayan araç
              sürücüleri, 5. Basamağa yükselir ve trafik sigortasını yenilerken
              %15 hasarsızlık indirimi kazanır.
            </div>
          </v-tab-item>
          <v-tab-item>
            <table>
              <tbody>
                <tr>
                  <td></td>
                  <td colspan="2">
                    <p style="text-align: center;">
                      <strong>Maddi (TL)</strong>
                    </p>
                  </td>
                  <td colspan="2">
                    <p style="text-align: center;">
                      <strong>Sağlık Gideri (TL)</strong>
                    </p>
                  </td>
                  <td colspan="2">
                    <p style="text-align: center;">
                      <strong>Sakatlanma ve Ölüm (TL)</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;">
                      <strong
                        ><span style="color: #00B050;">ARAÇ TÜRÜ</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;">
                      <strong
                        ><span style="color: #00B050;">ARAÇ BAŞI</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;">
                      <strong
                        ><span style="color: #00B050;">KAZA BAŞI</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;">
                      <strong
                        ><span style="color: #00B050;">KİŞİ BAŞI</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;">
                      <strong
                        ><span style="color: #00B050;">KAZA BAŞI</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;">
                      <strong
                        ><span style="color: #00B050;">KİŞİ BAŞI</span></strong
                      >
                    </p>
                  </td>
                  <td>
                    <p style="text-align: center;">
                      <strong
                        ><span style="color: #00B050;">KAZA BAŞI</span></strong
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td><p style="text-align: center;">Otomobil, Taksi</p></td>
                  <td><p style="text-align: center;">43.000</p></td>
                  <td><p style="text-align: center;">86.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">2.150.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">2.150.000</p></td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;">
                      Kamyonet, Kamyon, Minibüs, Çekici
                    </p>
                  </td>
                  <td><p style="text-align: center;">43.000</p></td>
                  <td><p style="text-align: center;">86.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">4.300.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">4.300.000</p></td>
                </tr>
                <tr>
                  <td><p style="text-align: center;">Traktör</p></td>
                  <td><p style="text-align: center;">43.000</p></td>
                  <td><p style="text-align: center;">86.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">2.150.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">2.150.000</p></td>
                </tr>
                <tr>
                  <td><p style="text-align: center;">Motosiklet</p></td>
                  <td><p style="text-align: center;">43.000</p></td>
                  <td><p style="text-align: center;">86.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">1.290.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">1.290.000</p></td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;">
                      Otobüs (Sürücü dâhil 18-30 koltuk)
                    </p>
                  </td>
                  <td><p style="text-align: center;">43.000</p></td>
                  <td><p style="text-align: center;">86.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">7.740.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">7.440.000</p></td>
                </tr>
                <tr>
                  <td>
                    <p style="text-align: center;">
                      Otobüs (Sürücü dâhil 31 ve üstü koltuk)
                    </p>
                  </td>
                  <td><p style="text-align: center;">43.000</p></td>
                  <td><p style="text-align: center;">86.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">13.330.000</p></td>
                  <td><p style="text-align: center;">430.000</p></td>
                  <td><p style="text-align: center;">13.330.000</p></td>
                </tr>
              </tbody>
            </table>
            <div class="mt-5">
              ** Zorunlu trafik sigortası teminat limitleri her yıl
              değişmektedir. 2021 için Hazine Müsteşarlığının belirlemiş olduğu
              trafik sigortası teminat limitleri yukarıdaki gibidir.
            </div>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </v-container>
  </section>
</template>

<script>
export default {
  data () {
    return {
      tab: null,
      currentYear: new Date().getFullYear(),
      buttons: [
        {
          id: 1,
          text: 'Trafik Sigortası Tavan Fiyatları 2021'
        },
        {
          id: 2,
          text: 'Trafik Sigortası Hasarsızlık İndirimi Basamakları'
        },
        {
          id: 3,
          text: 'Trafik Sigortası Teminat Limitleri'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
@import '@/css/variables';
.table {
  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    margin: 0;
    overflow: hidden;
    box-sizing: border-box;
    * {
      box-sizing: border-box;
    }
  }
  tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
  }

  th,
  td {
    border: 2px solid #ebeef5;
    box-sizing: border-box;
    min-width: 1em;
    padding: 3px 5px;
    position: relative;
    text-align: center;
  }
  th {
    background-color: $primary;
    font-weight : 400;
    color: #fff;
    padding-top: 6px;
    font-weight: 500;
  }
}
</style>
